import { IInterest } from "api/types";

import { useAppState } from "AppState";
import PanelLayout from "components/common/PanelLayout/PanelLayout";
import WizardButtonGroup from "components/common/WizardButtonGroup/WizardButtonGroup";
import { ButtonGroup } from "components/common/WizardButtonGroup/WizardButtonGroup.style";
import { CustomerDataContext } from "components/Gates/CustomerDataGate";
import { TabletDataContext } from "components/Gates/TabletDataGate";
import React, { FunctionComponent, useContext, useState } from "react";
import { getApolloContext } from "react-apollo";
import OnboardingContainer from "screens/Onboarding/Onboarding.container";

import InterestSelector from "components/ElementSelector/ElementSelector";
import Interests from "components/ElementSelector/Interests/Interests";
import { shouldHideUsageType } from "components/UsageTypeSelector/utils";

import Text from "components/common/Text/Text";
import styled from "styled-components";

import useReactRouter from "use-react-router";
import { updateCustomerInterestsAndUsageTypes } from "utils/apis";
import { Container, WidgetWrapper } from "./common/TabbedContainers";
import EditProfileTabs, { EditProfileTabNames } from "./tabs/EditProfileTabs";

export default function EditInterestSelection(): JSX.Element {
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const { history, location } = useReactRouter();
  const tabletData = useContext(TabletDataContext);
  const { client } = useContext(getApolloContext());
  const loggedCustomer = useContext(CustomerDataContext);

  const {
    locationName,
    availableInterests,
    selectedUsageTypeIdsOnServer,
    selectedInterestIds,
    setSelectedInterestIds,
    setSelectedInterestIdsOnServer,
    localInterestSelectionChanged
  } = useAppState();
  const setSelectedInterests = (changedInterests: IInterest[]) => {
    setSelectedInterestIds(
      changedInterests.filter(x => x.checked).map(x => x.id)
    );
    setShowSuccessMessage(false);
  };

  const onUpdateInterests = async () => {
    if (client) {
      await updateCustomerInterestsAndUsageTypes(
        client,
        loggedCustomer ? loggedCustomer.authToken : "",
        selectedInterestIds,
        selectedUsageTypeIdsOnServer
      );
      setSelectedInterestIdsOnServer(selectedInterestIds);
      setShowSuccessMessage(true);
    }
  };

  return (
    <PanelLayout
      title={locationName}
      titleSecondary="Edit Interests"
      closeButtonHandler
    >
      <Container>
        <EditProfileTabs
          hideUsageTypeTab={shouldHideUsageType(tabletData)}
          hasNoInterests={tabletData && tabletData.hasNoInterests}
          walletStatus={location.state.walletStatus}
          history={history}
          currentTab={EditProfileTabNames.Interests}
        />
        <WidgetWrapper enlarged transparent>
          <>
            <InterestSelector
              title="Choose your interests"
              allElements={availableInterests}
              initialSelectedIds={selectedInterestIds}
              onChange={setSelectedInterests}
              component={<Interests />}
            />
            {localInterestSelectionChanged() && (
              <ButtonGroup>
                <WizardButtonGroup
                  rightCaption="Update"
                  rightClick={onUpdateInterests}
                />
              </ButtonGroup>
            )}
            {showSuccessMessage && (
              <SuccessMessage h4 fullWidth center tertiary>
                We've updated your selection!
              </SuccessMessage>
            )}
          </>
        </WidgetWrapper>
      </Container>
    </PanelLayout>
  );
}

const SuccessMessage = styled(Text)`
  position: absolute;
  bottom: 8vh;
  display: block;
`;



// WEBPACK FOOTER //
// ./src/screens/Main/edit-profile/EditInterestSelection.tsx